import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_SONS_OF_BEHEMAT: {
    name: 'Battletome: Sons of Behemat',
    type: 'battletome',
  },
  ERRATA_NOV_2020: {
    name: 'Errata (November 2020)',
    type: 'errata',
  },
  ERRATA_MARCH_2021: {
    name: 'Errata (March 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/11/5hJh6gsSHuqScJiT.pdf',
  },
  ERRATA_JULY_2021: {
    name: 'Errata (July 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/11/DFG60Pr3z7N58B4w.pdf',
  },
  WHITE_DWARF_AUGUST_2021: {
    name: 'White Dwarf (August 2021)',
    type: 'white_dwarf',
  },
  ERRATA_AUGUST_2021: {
    name: 'Errata (August 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/11/JVwZBkal7nIn0oma.pdf',
  },
  ERRATA_JULY_2022: {
    name: 'Errata (July 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/11/UAXqGclWKSPiDS3F.pdf',
  },
} satisfies TRuleSources

export default rule_sources
